<template>
  <section class="w-full bg-white lg:px-4 lg:py-16">
    <div
      class="search-cta w-full lg:max-w-[1200px] lg:mx-auto flex flex-col gap-6 px-4 py-6 border-y border-solid lg:border-[3px] lg:rounded-xl lg:p-12 lg:shadow-[0px_8px_24px_-3px_rgba(16,24,40,0.05),0px_8px_24px_-3px_rgba(16,24,40,0.1)]"
      :style="frameStyle"
    >
      <div class="flex flex-col items-center gap-1 text-center text-[#262626]">
        <p
          v-if="overlineText"
          class="text-[11px] lg:text-[14px] font-semibold uppercase leading-5 tracking-[1px]"
        >
          {{ overlineText }}
        </p>
        <h2
          class="text-[32px] lg:text-[36px] font-medium leading-[40px] lg:leading-[44px] tracking-tight"
        >
          {{ headingText }}
        </h2>
      </div>

      <MagicSearchBar
        :placeholder-text="placeholderText"
        :button-label="buttonLabel"
        :search-path="formAction"
        :site_context="site_context"
      />
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { themeSearchCtaFrameStyleFor } from '@/utils/siteThemeColors';
import MagicSearchBar from '@/Shared/MagicSearchBar.vue';

const props = defineProps({
  overlineText:    { type: String, default: '' },
  headingText:     { type: String, default: 'Znajdź badanie, zabieg lub specjalistę' },
  placeholderText: { type: String, default: 'Wybierz lub wpisz' },
  buttonLabel:     { type: String, default: 'Szukaj' },
  formAction:      { type: String, default: '/szukaj' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context:    { type: String, default: null },
});

const frameStyle = computed(() => themeSearchCtaFrameStyleFor(props.site_context));
</script>
